// 260721nrai: r4 merge — Generic progress UI for demo-generation tasks (start + poll tick endpoints).
(function ($) {
  'use strict';

  function csrfToken() {
    return $('meta[name="csrf-token"]').attr('content');
  }

  function updateProgress($root, status) {
    var $bar = $root.find('.demo-generation-progress__bar');
    var $step = $root.find('.demo-generation-progress__step');
    var $detail = $root.find('.demo-generation-progress__detail');
    var $percent = $root.find('.demo-generation-progress__percent');
    var percent = status.percent || 0;

    $bar.css('width', percent + '%').attr('aria-valuenow', percent);
    $percent.text(percent + '%');

    if (status.step_total > 1) {
      $step.text('Schritt ' + status.step_number + ' von ' + status.step_total + ' – ' + (status.step_label || ''));
    } else if (status.step_label) {
      $step.text(status.step_label);
    } else {
      $step.text(status.message || 'Wird verarbeitet …');
    }

    if (status.step_items_total > 0) {
      $detail.text(status.step_processed + ' / ' + status.step_items_total + ' Einträge in diesem Schritt');
    } else if (status.message) {
      $detail.text(status.message);
    } else {
      $detail.text('');
    }

    if (status.error) {
      $root.addClass('demo-generation-progress--error');
      $detail.text(status.error);
    }

    if (status.done && !status.error) {
      $root.addClass('demo-generation-progress--done');
    }
  }

  function pollTick($root, tickUrl) {
    $.ajax({
      url: tickUrl,
      dataType: 'json',
      method: 'GET'
    }).done(function (status) {
      updateProgress($root, status);

      if (status.done) {
        $root.trigger('demo-generation:done', [status]);
        return;
      }

      window.setTimeout(function () {
        pollTick($root, tickUrl);
      }, 250);
    }).fail(function (xhr) {
      var message = 'Fortschritt konnte nicht abgerufen werden';
      if (xhr.responseJSON && xhr.responseJSON.error) {
        message = xhr.responseJSON.error;
      }
      updateProgress($root, { done: true, error: message, percent: 0, step_total: 0 });
      $root.trigger('demo-generation:error', [message]);
    });
  }

  function startGeneration($root, startUrl, tickUrl, params) {
    var $button = $root.find('.demo-generation-start');
    var $progress = $root.find('.demo-generation-progress');

    $button.addClass('hidden');
    $progress.removeClass('hidden');
    updateProgress($root, {
      percent: 0,
      step_number: 0,
      step_total: 0,
      message: 'Wird vorbereitet …'
    });

    $.ajax({
      url: startUrl,
      data: params || {},
      dataType: 'json',
      method: 'POST',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('X-CSRF-Token', csrfToken());
      }
    }).done(function (status) {
      updateProgress($root, status);
      if (status.done) {
        $root.trigger('demo-generation:done', [status]);
        return;
      }
      pollTick($root, tickUrl);
    }).fail(function (xhr) {
      var message = 'Start fehlgeschlagen';
      if (xhr.responseJSON && xhr.responseJSON.error) {
        message = xhr.responseJSON.error;
      }
      updateProgress($root, { done: true, error: message, percent: 0, step_total: 0 });
      $root.trigger('demo-generation:error', [message]);
    });
  }

  $(document).on('click', '.demo-generation-start', function (event) {
    event.preventDefault();
    var $root = $(this).closest('.demo-generation-control');
    if ($root.data('running')) {
      return;
    }
    $root.data('running', true);

    var params = $root.data('params') || {};
    if (typeof params === 'string') {
      try {
        params = JSON.parse(params);
      } catch (e) {
        params = {};
      }
    }

    startGeneration(
      $root,
      $root.data('start-url'),
      $root.data('tick-url'),
      params
    );
  });
})(jQuery);
